import React from "react";

const ExchangePage = () => {
  return <div>ExchangePage</div>;
};

export default ExchangePage;
